import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ConfigInfo } from "@interfaces/config-info.interface";
import { ThesaurusService } from "@thesaurus-service/thesaurus.service";
import { catchError, of } from "rxjs";

@Component({
    selector: 'app-config',
    templateUrl: './config.component.html',
    styleUrl: './config.component.css',
    standalone: false
})
  export class ConfigComponent {
  
    subscription: any;

    configInfo?: ConfigInfo;

    localeCode:string = '';
    appServer:string = '';
    xFwdProto:string = '';
  
    constructor(
      private thesaurusService: ThesaurusService,
      private route: ActivatedRoute
    ) {}
  
    ngOnInit(): void {
      this.subscription = this.route.queryParams.subscribe(queryParams => {
          this.thesaurusService.getThesaurusConfigInformation().pipe(
                    catchError(error => {
                      this.thesaurusService.setThesaurusServiceError(true);
                      // Handle the error by returning undefined or a default ConfigInfo object
                      return of(undefined);
                    })
          ).subscribe( 
              data => this.configInfo = data
          );
      });
      this.localeCode = window.navigator.language;
      this.appServer = location.host;
      this.xFwdProto = location.protocol.split(':')[0];
    }
  
    ngOnDestroy(): void {
      this.subscription.unsubscribe();
    }

  }
  